<template>
  <nuxt-link class="content" :to="path" @click.capture="handleClickPath">
    <Icon :name="icon" color="primary" class="icon" />
    <span class="label">
      <span class="text">{{ text }}</span>
      <Icon
        v-if="isTrialItem"
        class="icon-gift"
        size="2rem"
        name="fluent-emoji-flat:wrapped-gift"
      />
    </span>
  </nuxt-link>
</template>
<script lang="ts" setup>
interface Props {
  id: string;
  libraryBookId: string;
  contentType: string;
  path: string;
  text: string;
  icon?: string;
  locked?: boolean;
  lockedContent: string;
}
const props = defineProps({
  id: null,
  libraryBookId: null,
  contentType: null,
  path: null,
  text: null,
  icon: { default: 'nomad:course' },
  locked: { type: Boolean, default: false },
  lockedContent: null
});

const { handleClickPath, isTrialItem } = useCategoryContentClick(
  {
    lockedContent: props.lockedContent,
    id: props.id,
  },
  props.path
);
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap_n);
}
.progress {
  flex-shrink: 0;
}
.icon {
  flex: 0 0 auto;
  color: var(--color_secondary);
}
.label {
  position: relative;
  padding: 1rem 0;
  transition: color 300ms $ease-out-quad;
  color: var(--color_neutral_500);
  .icon-gift {
    margin-left: 0.6rem;
  }
  @include font('n', '500');
  .text {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      bottom: -0.5rem;
      left: 0;
      width: 100%;
      height: 0.5rem;
      transform: scaleX(0);
      transform-origin: 0%;
      transition: transform 300ms $ease-out-quad;
      background: var(--color_secondary);
    }
  }
}
a {
  &:hover,
  &:focus,
  &.active,
  &.disabled {
    .label {
      .text {
        color: var(--color_secondary);
        &::before {
          transform: scaleX(1);
        }
      }
    }
  }
}
</style>
